import React from "react";
import LoginPage from "../pages/LoginPage";


export const PublicPage = () => {
      return (<LoginPage/>);
}